import css from 'styled-jsx/css'
import { colors, fontSizes } from 'theme'

export default css`
  .input-tag {
    position: relative;
  }
  .input-tag.show-error :global(.react-selectize-control) {
    border: 1px solid ${colors.danger} !important;
  }
  .input-tag :global(.react-selectize-toggle-button-container) {
    display: none !important;
  }

  .input-tag :global(.dropdown-menu) {
    display: none;
    transition: all 0.3s;
  }

  .input-tag :global(.react-selectize-control) {
    transition: all 0.3s;
  }

  .input-tag :global(.mini-placeholder) {
    transition: all 0.3s;
    position: absolute;
    top: 35%;
    left: 0.5rem;
    font-size: ${fontSizes.small};
  }

  .input-tag.show-mini-placeholder :global(.react-selectize-control) {
    padding-top: 1rem;
  }
  .input-tag.show-mini-placeholder :global(.mini-placeholder) {
    z-index: 2;
    font-size: 0.8rem;
    top: 0rem;
    left: 0.5rem;
    color: ${colors.gray};
  }
  .input-tag.show-error :global(.mini-placeholder.mailbox-error) {
    color: ${colors.danger};
  }
`
